export default {
    required:"Este campo es obligatorio.",
    email:"El campo email es incorrecto."
}